import { z } from 'zod'

export const taskCompletedSchema = z.object({
  programUuid: z.string().uuid(),
  masterTaskId: z.string(),
  memberStatus: z.string(),
  resolutionType: z.string(), //done | dismiss
  doneType: z.string().nullable(), //null when resolutionType=dismiss or cleared by attached card
  taskUuid: z.string().nullable(), //null when taskinhas_group
  taskType: z.string(),
  reachOutGenerationSource: z.string().optional(),
})
